import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LooksOneSharpIcon from '@mui/icons-material/LooksOneSharp';
import LooksTwoSharpIcon from '@mui/icons-material/LooksTwoSharp';

const rowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  marginBottom: 2,
};

function StationStatus() {
  return (
    <Box>
      <Box sx={rowSx}>
        <Button
          size="small"
          color="primary"
          style={{ pointerEvents: 'none' }}
          endIcon={<LooksOneSharpIcon />}
        >
          Deck
        </Button>
        <Typography sx={{ fontSize: { xs: '1.1rem', md: '1.4rem' }, fontWeight: 300 }}>
          Online
        </Typography>
      </Box>
      <Box sx={rowSx}>
        <Button
          size="small"
          color="secondary"
          style={{ pointerEvents: 'none' }}
          endIcon={<LooksTwoSharpIcon />}
        >
          Deck
        </Button>
        <Typography sx={{ fontSize: { xs: '1.1rem', md: '1.4rem' }, fontWeight: 300 }}>
          Online
        </Typography>
      </Box>
    </Box>
  );
}

export default StationStatus;
